import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { p as pick_1 } from './pick-bfea8c03.js';
import { q as addPageLoadDataInfoToAnalyticsEvent } from './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import { b as priceToFloat } from './utils-913bdf8a.js';
import { p as parseJsonResponse } from './utils-15ad90ec.js';
import { C as CR } from './types-aae419ee.js';

const softwareDocumentsToSoftwareInfo = (softwareDocuments, labels) => {
  if (!isEmpty_1(labels)) {
    return Object.assign(Object.assign({}, pick_1(labels, [
      'availableVersionsLabel',
      'operatingSystemsLabel',
      'languageLabel',
      'formatLabel',
      'sizeLabel',
      'dateLabel',
      'versionLabel',
      'downloadLabel',
      'viewLabel',
    ])), { softwareDocuments });
  }
  return null;
};
const requestCrProductSelectorAvailability = (selectorConfig) => fetch(selectorConfig.scUrl, {
  headers: { Authorization: selectorConfig.token },
}).then((res) => parseJsonResponse(res));
const setProductSelectorAvailability = async (selectorConfig, productSelectorConfig) => {
  let showProductSelector;
  if (productSelectorConfig.type === CR) {
    const { status } = await requestCrProductSelectorAvailability(selectorConfig);
    showProductSelector = status;
  }
  else {
    showProductSelector = true;
  }
  return showProductSelector;
};
const formatPrice = (price) => (price ? priceToFloat(price) : 'undefined');
const gatherDataForViewItemAnalyticsEvent = (productId, productInfo, ctaArea, productAvailabilityInfo, isApc) => {
  var _a, _b, _c, _d, _e;
  return Object.assign({ template_name: 'Products', items: [
      {
        item_brand: (_a = productInfo === null || productInfo === void 0 ? void 0 : productInfo.brand) !== null && _a !== void 0 ? _a : '',
        item_id: productId !== null && productId !== void 0 ? productId : '',
        item_name: (_b = productInfo === null || productInfo === void 0 ? void 0 : productInfo.description) !== null && _b !== void 0 ? _b : '',
        currency: (_c = ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.currency) !== null && _c !== void 0 ? _c : 'EUR',
        price: formatPrice(isApc ? (_e = (_d = productAvailabilityInfo === null || productAvailabilityInfo === void 0 ? void 0 : productAvailabilityInfo.prices) === null || _d === void 0 ? void 0 : _d[productId]) === null || _e === void 0 ? void 0 : _e.activePriceValue : ctaArea === null || ctaArea === void 0 ? void 0 : ctaArea.price),
        item_category: '',
        index: '',
        variant: '',
      },
    ] }, addPageLoadDataInfoToAnalyticsEvent());
};
const checkForLongWordInString = (pillars, threshold) => pillars.some((pillar) => pillar.pillarLabel.split(' ').some((word) => word.length > threshold));
const checkForShowMore = (pillars, isLongWordPresent) => {
  const pillarsPerRow = isLongWordPresent ? 3 : 4;
  const isShowMoreRequired = pillars.length > pillarsPerRow;
  return { isShowMoreRequired, pillarsPerRow };
};

export { softwareDocumentsToSoftwareInfo as a, checkForShowMore as b, checkForLongWordInString as c, gatherDataForViewItemAnalyticsEvent as g, setProductSelectorAvailability as s };
